export { Home } from "./Home/Home.js";
export { Tech_Specs } from "./Tech_Specs/Tech_Specs.js";
export { Compare } from "./Compare/Compare.js";